export class StatisticsResponse {
    TotalPharmacies: number;
    PharmaciesWithRelayEnabled: number;
    PharmaciesStoppedUsingRelay: number;
    PharmaciesWithSignalREnabled: number;
    PharmaciesWithWebAPIEnabled: number;
    PharmaciesGroups: number;
    NamespacesInUse: number;
    AzureAccountsInUse: number;
    EndpointsInUse: number;

    constructor() {}
}
